import React from 'react'

import {
    DropdownItemDiv,
    DropdownText
} from '../../Styles/Components/DropdownItemStyles'

function DropdownItem(props){
    var item = props.item

    var style

    if('color' in item){
        style = {color: item.color}
    }

    return (
        <DropdownItemDiv onClick={item.onClick}>
            <DropdownText style={style}>
                {item.item_name}
            </DropdownText>
        </DropdownItemDiv>
    )
}

export default DropdownItem